export const ROUTES = {
    seeWorkshop: "preview",
    seePlaylist: "play",
    createPad: "create-pad",
    editPlaylistRecipients: "edit-recipients",
    create: "create",
    edit: "edit",
};
